import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import { Button } from 'chaoskit/src/components';
import { kebabCase, toLower } from 'lodash-es';

import { config } from '../helpers/config';
import BaseLayout from '../layouts/BaseLayout';
import Hero from '../partials/Hero';
import { Data } from '../components';

const generateSlug = title => kebabCase(toLower(title));

const Security = props => {
  const {
    data: {
      file: { childDataYaml: pageData },
    },
  } = props;

  return (
    <BaseLayout>
      <Helmet
        title={pageData.title}
        meta={[{ name: 'description', content: pageData.description }]}
      />
      <Hero compact className="u-gradient--teal-darkBlue">
        <div className="hero-content">
          <div className="container">
            <div className="hero-titleWrapper">
              <h1 className="hero-title">
                <Data>{pageData.hero.heading}</Data>
              </h1>
            </div>
          </div>
        </div>
      </Hero>
      <section className="section">
        <div className="container">
          <div className="u-textLarge u-mb--xlarge">
            <Data markdown>{pageData.intro.blurb}</Data>

            <div className="u-textCenter u-mt--large">
              <Button url={config.latestSecurityFAQ} type="primary">
                Download Security FAQ
              </Button>
            </div>
          </div>
          {pageData.sections && (
            <ul className="blockGrid blockGrid--largeGutter">
              {pageData.sections.map(section => (
                <li key={section.title}>
                  <h3 id={generateSlug(section.title)}>{section.title}</h3>
                  <Data markdown>{section.blurb}</Data>
                  {section.subSections && (
                    <div className="u-mt--large">
                      <ul className="blockGrid blockGrid-2@medium blockGrid--largeGutter">
                        {section.subSections.map(sub => (
                          <li key={sub.title}>
                            <h5
                              id={generateSlug(sub.title)}
                              className="u-textMuted u-textFluid--large"
                            >
                              {sub.title}
                            </h5>
                            <Data markdown>{sub.blurb}</Data>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </BaseLayout>
  );
};

Security.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Security;

export const pageQuery = graphql`
  query SecurityPageData {
    file(name: { eq: "security" }) {
      childDataYaml {
        title
        description
        hero {
          heading
        }
        intro {
          blurb
        }
        sections {
          title
          blurb
          subSections {
            title
            blurb
          }
        }
      }
    }
  }
`;
